import * as angular from "angular";

let HousesViewComponent = {
    selector: "vcHousesView",
    templateUrl: "/angular/components/house/houses-view.component.html",
    bindings: {
        doubleToolbar: "=?",
    },
    controller: "PeopleController",
};

angular
    .module("house")
    .component(HousesViewComponent.selector, HousesViewComponent);
